<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" :label-width="labelWidth">
        <!-- 车辆升级单号 -->
        <el-form-item :label="$t('upgrade.upgradeNum') + ':'">
          <el-input
            v-model="queryParams.upgradeOrderNum"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 质量反馈单号 -->
        <el-form-item :label="$t('upgrade.feedbackNum') + ':'">
          <el-input
            v-model="queryParams.qualityFeedbackId"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 升级结束时间 -->
        <el-form-item :label="$t('upgrade.endTime') + ':'">
          <el-date-picker
            v-model="queryParams.upgradeTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button class="primary-btn" type="primary" @click="doSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="tableData"
        :max-height="maxHeight"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          type="index"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 车辆升级单号 -->
        <el-table-column
          property="upgradeOrderNum"
          :label="$t('upgrade.upgradeNum')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 主题 -->
        <el-table-column
          property="subject"
          :label="$t('upgrade.theme')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 质量反馈单号 -->
        <el-table-column
          property="qualityFeedbackId"
          :label="$t('upgrade.feedbackNum')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 升级结束时间 -->
        <el-table-column
          property="upgradeEndDate"
          :label="$t('upgrade.endTime')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 升级原因 -->
        <el-table-column
          property="upgradeReason"
          :label="$t('upgrade.reason')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- VIN处理情况 -->
        <el-table-column
          :label="$t('upgrade.vinStatusLabel')"
          min-width="120px"
          align="center"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.vinStatus === 0">{{ $t('upgrade.vinStatusIncomplete') }}</span>
            <span v-else-if="scope.row.vinStatus === 1" class="successColor">{{ $t('upgrade.vinStatusCompleted') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="availableClaimVinCount" :label="$t('upgrade.availableClaimVinCount')" width="120" align="center" />

        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          :render-header="$globalRenderHeader"
          :width="{ ru: 345, en: 230, vi: 240, es: 300, fa: 205 }[$i18n.locale] || 180"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" @click="handelUpgrade(scope.row, 'view')">{{
              $t("operate.view")
            }}</el-button>
            <!-- 处理 -->
            <el-button type="text" v-show="scope.row.vinStatus == 0" @click="handleClick(scope.row)">{{ $t("restockInfo.process") }}</el-button>
            <!-- 发起索赔 -->
            <el-button type="text" v-if="(scope.row.status === 1 || scope.row.status === '1') && scope.row.availableClaimVinCount > 0" @click="handelUpgrade(scope.row, 'claim')">{{ $t("upgrade.initiateClaim") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { setStorageNew } from "@/util/localStor";
import { getUpgradeOrderList } from "@/api/vehicleUpgrade.js";
import listCurd from "@/mixins/listCurd";
export default {
  mixins: [listCurd],
  data() {
    return {
      maxHeight: null,
      queryParams: {}, // 查询参数
      listMethod: getUpgradeOrderList, // 获取表格数据api
      type: "upgradeIndex",
    };
  },
  created() {
    this.removeItem("upgradeIndex");
    // 获取表格数据
    this.getList();
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "100px",
        ru: "235px",
        en: "225px",
        vi: "205px",
        es: "275px",
        fa: "140px",
      };
      return widthMap[this.$i18n.locale] || "125px";
    },
  },
  methods: {
    // 参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      if ((params.upgradeTime || []).length === 2) {
        params.upgradeEndDateStart = params.upgradeTime?.[0];
        params.upgradeEndDateEnd = params.upgradeTime?.[1];
      }
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 数据
    // getList() {
      // getUpgradeOrderList().then((res) => {
      // })
    // },
    // 查看 发起索赔
    handelUpgrade(row, status) {
      console.log(row.upgradeOrderId, status);
      // setStorageNew('upgradeData', data)
      this.$router.push({
        path: "/qualityNew/upgradeDetail",
        query: {
          upgradeOrderId: row.upgradeOrderId,
          status: status
        }
      });

    },
    // handelView(row) {
    //   this.$router.push({ path: "/qualityNew/upgradeDetail" });
    // },
    // 处理
    handleClick(row) {
      setStorageNew("upgradeData", row);
      this.$router.push({
        path: "/qualityNew/upgradeProcess",
      });
    },
    // 发起索赔
    // claimClick(row) {},
  },
};
</script>
